import React from 'react';
import PageInfoModal from '../PageInfoModal/PageInfoModal';

const SYLLABUS_INFO_ITEMS = [
  { icon: 'book', text: 'Mövcud sillabus planlarınızın siyahısına bu bölmədən baxa bilərsiniz.' },
  { icon: 'plus-circle', text: '"Yeni Təlim" düyməsi ilə yeni sillabus/kurs yarada bilərsiniz.' },
  { icon: 'folder-plus', text: 'Hər təlimin içinə klik edərək yeni bölmə (section) əlavə edə bilərsiniz.' },
  { icon: 'file-earmark-plus', text: 'Bölmə daxilindəki "+" düyməsi ilə dərs əlavə edə bilərsiniz.' },
  { icon: 'pencil-square', text: 'Mövcud bölmə və dərs adlarını redaktə edə bilərsiniz.' },
];

const HeaderForSyllabus = ({ onTrainingsClick, onAddTrainingClick }) => {
  return (
    <div style={{
      background: '#fff',
      border: '1px solid #E5E7EB',
      borderRadius: 10,
      padding: '14px 20px',
      marginBottom: '0',
      flexShrink: 0,
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <PageInfoModal title="Sillabus" items={SYLLABUS_INFO_ITEMS} />
        <div style={{ width: 34, height: 34, background: '#EFF6FF', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            <line x1="8" y1="7" x2="16" y2="7"/>
            <line x1="8" y1="11" x2="14" y2="11"/>
          </svg>
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <h3 style={{ margin: 0, fontWeight: 700, fontSize: 15, color: '#0F172A', letterSpacing: '-0.2px' }}>Sillabus</h3>
            <span style={{ background: '#EFF6FF', color: '#2563EB', fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20, border: '1px solid #BFDBFE', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Xüsusi</span>
          </div>
          <p style={{ margin: 0, fontSize: 12, color: '#94A3B8', marginTop: 2 }}>Təlim planlarını idarə edin</p>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }} />
    </div>
  );
};

export default HeaderForSyllabus;